export interface ICouponShowCase {
    head: string
    result: string
    phrase1: string
    phrase2: string
    imagePath: string
    couponCode: string
}

export class CouponShowCaseModel implements ICouponShowCase {
    head = ''
    result = ''
    phrase1 = ''
    phrase2 = ''
    imagePath = ''
    couponCode = ''
}
